import { render } from "./RequirementsModal.vue?vue&type=template&id=4dbaecfd&scoped=true&ts=true"
import script from "./RequirementsModal.vue?vue&type=script&lang=ts"
export * from "./RequirementsModal.vue?vue&type=script&lang=ts"

import "./RequirementsModal.vue?vue&type=style&index=0&id=4dbaecfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbaecfd"]])

export default __exports__